import React, { useState, useEffect, Fragment } from 'react';
import { get } from '../../Services/http';
import BuyButton from '../BuyButton';
import { translate } from '../../Services/translation';
import { add as addToCartService } from '../../Services/Cart.service';
import { useDispatch } from 'react-redux';
import { receive } from '../../Actions/Cart.action';
import SimplePopup from '../SimplePopUp';
import { useSelector } from 'react-redux';
import { SUBSCRIPTION_INTERVAL_MONTHLY } from '../../constants';
import { GetPacketSizeToAdd } from '../../Services/Cart.service';

const MyPageRecommendationLastOrder = (props) => {
  const lastOrderDetails =
    props.customerRecommendation && JSON.parse(props.customerRecommendation);
  const href = '#';
  const [subscriptionSelected, setsubscriptionSelected] = useState(false);
  const [oneTimeShopSelected, setoneTimeShopSelected] = useState(false);
  const [noOptionSelected, setnoOptionSelected] = useState(true);
  const cart = useSelector((state) => state.cart);
  const anyProductNotBuyable = lastOrderDetails && 
  lastOrderDetails.some(x => !x.customerRecommendationItemLeft.canBuy || !x.customerRecommendationItemRight.canBuy);

  const [showPopup, setShowPopup] = useState(false);
  const handleButtonClick = () => {
    setShowPopup(true);
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    if (props.subscriptionExists) {
      setsubscriptionSelected(false);
      setoneTimeShopSelected(true);
      setnoOptionSelected(false);
    } 
  }, [props, props.subscriptionExists]);

  const dispatch = useDispatch();
  const addItemsToCart = async () => {
    try {
      for (const x of lastOrderDetails) {
        if (x.customerRecommendationItemRight && x.customerRecommendationItemLeft &&
          x.customerRecommendationItemRight.articleNumber === x.customerRecommendationItemLeft.articleNumber) {
          const packetSize = GetPacketSizeToAdd(x.recommendationLensDurationCategory, 
            x.customerRecommendationItemRight.packageSize);
          await addToCartService({
            articleNumber: x.customerRecommendationItemRight.articleNumber,
            quantity: 1,
            rightStrength: x.customerRecommendationItemRight.strength,
            rightCurve: x.customerRecommendationItemRight.curve,
            rightDiameter: x.customerRecommendationItemRight.diameter,
            rightCylinder: x.customerRecommendationItemRight.cylinder,
            rightAxis: x.customerRecommendationItemRight.axis,
            rightEyeAdd: x.customerRecommendationItemRight.add,
            rightColor: x.customerRecommendationItemRight.color,
            rightPacket: subscriptionSelected ? packetSize
            : Number.parseInt(x.customerRecommendationItemRight.packet),
            leftStrength: x.customerRecommendationItemLeft.strength,
            leftCurve: x.customerRecommendationItemLeft.curve,
            leftDiameter: x.customerRecommendationItemLeft.diameter,
            leftCylinder: x.customerRecommendationItemLeft.cylinder,
            leftAxis: x.customerRecommendationItemLeft.axis,
            leftEyeAdd: x.customerRecommendationItemLeft.add,
            leftColor: x.customerRecommendationItemLeft.color,
            leftPacket: subscriptionSelected ? packetSize
            : Number.parseInt(x.customerRecommendationItemLeft.packet),
            rightEyeProductNumber: x.customerRecommendationItemRight.eyeProductNumber,
            leftEyeProductNumber: x.customerRecommendationItemLeft.eyeProductNumber,
            subscription: subscriptionSelected,
            lensDurationCategory: x.recommendationLensDurationCategory,
          });
        } else {
          if (x.customerRecommendationItemRight && x.customerRecommendationItemRight.strength) {
            await addToCartService({
              articleNumber: x.customerRecommendationItemRight.articleNumber,
              quantity: 1,
              rightStrength: x.customerRecommendationItemRight.strength,
              rightCurve: x.customerRecommendationItemRight.curve,
              rightDiameter: x.customerRecommendationItemRight.diameter,
              rightCylinder: x.customerRecommendationItemRight.cylinder,
              rightAxis: x.customerRecommendationItemRight.axis,
              rightEyeAdd: x.customerRecommendationItemRight.add,
              rightColor: x.customerRecommendationItemRight.color,
              rightPacket: subscriptionSelected ? GetPacketSizeToAdd(x.recommendationLensDurationCategory, 
                x.customerRecommendationItemRight.packageSize)
              : Number.parseInt(x.customerRecommendationItemRight.packet),
              rightEyeProductNumber: x.customerRecommendationItemRight.eyeProductNumber,
              subscription: subscriptionSelected,
              lensDurationCategory: x.recommendationLensDurationCategory,
            });
          }
          if (x.customerRecommendationItemLeft && x.customerRecommendationItemLeft.strength) {
            await addToCartService({
              articleNumber: x.customerRecommendationItemLeft.articleNumber,
              quantity: 1,
              leftStrength: x.customerRecommendationItemLeft.strength,
              leftCurve: x.customerRecommendationItemLeft.curve,
              leftDiameter: x.customerRecommendationItemLeft.diameter,
              leftCylinder: x.customerRecommendationItemLeft.cylinder,
              leftAxis: x.customerRecommendationItemLeft.axis,
              leftEyeAdd: x.customerRecommendationItemLeft.add,
              leftColor: x.customerRecommendationItemLeft.color,
              leftPacket: subscriptionSelected ? GetPacketSizeToAdd(x.recommendationLensDurationCategory, 
                x.customerRecommendationItemLeft.packageSize) 
              : Number.parseInt(x.customerRecommendationItemLeft.packet),
              leftEyeProductNumber: x.customerRecommendationItemLeft.eyeProductNumber,
              subscription: subscriptionSelected,
              lensDurationCategory: x.recommendationLensDurationCategory,
            });
          }
        }
        handleButtonClick();
      }
      setTimeout(() => {
        get(`/api/cart`)
          .then((response) => response.json())
          .then((result) => {
            dispatch(receive(result));
          });
      }, 1000);
    } catch (error) {
      console.error('Error adding items to cart:', error);
    }
  };

  const getSubscriptionSelectionSection = (index) => {
    return <div>

    {lastOrderDetails[index].allProductsAvailableForSubscription && !props.subscriptionExists && <a className={` product-detail__selector-link ${(cart.nonSubscriptionProductExists ? " product-detail__packagesize-disabled" : "")}`}
        onClick={() =>  {
          setsubscriptionSelected(true);
          setoneTimeShopSelected(false);
          setnoOptionSelected(false);
        }}
      >
        <div className="product-detail__typeofpurchase-section subscription">
          <div className="select-wrapper">
            <div className='typeofpurchase'>
              <input type="radio" checked={subscriptionSelected}
                disabled={cart.nonSubscriptionProductExists ||
                  (cart.lensDurationCategoryExistingInCart &&
                    cart.lensDurationCategoryExistingInCart !== lastOrderDetails[index].lensDurationCategory)}></input>
              <p className='name'>{translate("coptikk.product.subscription")}</p>
            </div>
            <p className='price'>{lastOrderDetails[index].pricePerMonth} / {translate("coptikk.checkout.cart.month")}</p>
          </div>
          <div className='description' dangerouslySetInnerHTML={{ __html: translate(
            lastOrderDetails[index].recommendationLensDurationCategory === SUBSCRIPTION_INTERVAL_MONTHLY ?
            "coptikk.subscription.mypages.recommendation.descriptionmonthly" : "coptikk.subscription.mypages.recommendation.descriptiondaily")}}>            
          </div>
        </div>
      </a>}

      {!(cart?.subscriptionExistsForLeftEye || cart?.subscriptionExistsForRightEye) && <a className={` product-detail__selector-link ${((cart.subscriptionExistsForRightEye || cart.subscriptionExistsForLeftEye)
        ? " product-detail__packagesize-disabled" : "")}`}
        onClick={() =>  {
          setoneTimeShopSelected(true);
          setsubscriptionSelected(false);
          setnoOptionSelected(false);
        }}
      >
        <div className="product-detail__typeofpurchase-section">
          <div className="select-wrapper">
            <div className='typeofpurchase'>
              <input type="radio" checked={oneTimeShopSelected}
                className={`product-detail__article-check`}
                disabled={(cart.subscriptionExistsForRightEye || cart.subscriptionExistsForLeftEye)}></input>
              <p className='name'>{translate("coptikk.product.onlyonetimeshop")}</p>
            </div>
            <p className='price'>{props.totalPrice}</p>
          </div>
        </div>
      </a>}

    </div>
  }

  return (
    <Fragment>
      {showPopup && (
          <SimplePopup onClose={handleClosePopup} checkoutUrl={props.checkoutUrl}/>
      )}
      {lastOrderDetails.map((customerRecommendation, index) => {
        let leftArticleNumber = customerRecommendation.customerRecommendationItemLeft ? customerRecommendation.customerRecommendationItemLeft.articleNumber : "";
        let rightArticleNumber = customerRecommendation.customerRecommendationItemRight ? customerRecommendation.customerRecommendationItemRight.articleNumber : "";
        return <div key={`${leftArticleNumber}${rightArticleNumber}`} className='my-recommendations__container'>
          {
            customerRecommendation.customerRecommendationItemRight && customerRecommendation.customerRecommendationItemRight.articleNumber &&
            <div>
              <div className='row my-recommendations__product'>
                <div className='columns small-2 my-recommendations__product-image'>
                  <img src={customerRecommendation.customerRecommendationItemRight.productImageUrl}></img>
                </div>
                <div className='columns small-6 my-recommendations__eye-spec-wrapper'>
                  <div className='my-recommendations__product-name'>
                    {customerRecommendation.customerRecommendationItemRight.name}
                  </div>
                  <div className='my-recommendations__product-category'>
                    {customerRecommendation.customerRecommendationItemRight.categoryName}
                  </div>
                  <div className='row'>
                    <div className='column small-8 my-recommendations__eye'>
                      {translate('coptikk.product.righteye')}
                    </div>
                  </div>
                  <div className='row'>
                    <div className='column small-12 my-recommendations__spec-row'>
                      {customerRecommendation.customerRecommendationItemRight.strength && <span className='my-recommendations__spec'>{customerRecommendation.customerRecommendationItemRight.strength}</span>}
                      {customerRecommendation.customerRecommendationItemRight.curve &&
                        <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.curve.short')}: {customerRecommendation.customerRecommendationItemRight.curve}</span>}
                      {customerRecommendation.customerRecommendationItemRight.diameter &&
                        <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.diameter.short')}: {customerRecommendation.customerRecommendationItemRight.diameter}</span>}
                      {customerRecommendation.customerRecommendationItemRight.cylinder &&
                        <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.cylinder.short')}: {customerRecommendation.customerRecommendationItemRight.cylinder}</span>}
                      {customerRecommendation.customerRecommendationItemRight.axis &&
                        <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.axis')}: {customerRecommendation.customerRecommendationItemRight.axis}</span>}
                      {customerRecommendation.customerRecommendationItemRight.add &&
                        <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.addfield')}: {customerRecommendation.customerRecommendationItemRight.add}</span>}
                      {customerRecommendation.customerRecommendationItemRight.color &&
                        <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.color')}: {customerRecommendation.customerRecommendationItemRight.color}</span>}
                    </div>
                  </div>
                  <div className='row'>
                    <div className={leftArticleNumber === rightArticleNumber ? 'column small-6' : 'column small-3'}>
                      <select disabled className='my-recommendations__disabled-select' value={customerRecommendation.customerRecommendationItemRight.packet}>
                        <option>{customerRecommendation.customerRecommendationItemRight.packet} {translate('coptikk.price.unit')} {customerRecommendation.customerRecommendationItemRight.price},-</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          {
            customerRecommendation.customerRecommendationItemLeft && customerRecommendation.customerRecommendationItemLeft.articleNumber &&
            <div>
              <div className='row my-recommendations__product'>
                {(leftArticleNumber !== rightArticleNumber) && <div className='columns small-2 my-recommendations__product-image'>
                  <img src={customerRecommendation.customerRecommendationItemLeft.productImageUrl}></img>
                </div>}
                <div className='columns small-6 my-recommendations__eye-spec-wrapper'>
                  {(leftArticleNumber !== rightArticleNumber) && <div className='my-recommendations__product-name'>
                    {customerRecommendation.customerRecommendationItemLeft.name}
                  </div>}
                  {(leftArticleNumber !== rightArticleNumber) && <div className='my-recommendations__product-category'>
                    {customerRecommendation.customerRecommendationItemLeft.categoryName}
                  </div>}
                  <div className='row'>
                    <div className='column small-8 my-recommendations__eye'>
                      {translate('coptikk.product.lefteye')}
                    </div>
                  </div>
                  <div className='row'>
                    <div className='column small-12 my-recommendations__spec-row'>
                      {customerRecommendation.customerRecommendationItemLeft.strength && <span className='my-recommendations__spec'>{customerRecommendation.customerRecommendationItemLeft.strength}</span>}
                      {customerRecommendation.customerRecommendationItemLeft.curve &&
                        <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.curve.short')}: {customerRecommendation.customerRecommendationItemLeft.curve}</span>}
                      {customerRecommendation.customerRecommendationItemLeft.diameter &&
                        <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.diameter.short')}: {customerRecommendation.customerRecommendationItemLeft.diameter}</span>}
                      {customerRecommendation.customerRecommendationItemLeft.cylinder &&
                        <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.cylinder.short')}: {customerRecommendation.customerRecommendationItemLeft.cylinder}</span>}
                      {customerRecommendation.customerRecommendationItemLeft.axis &&
                        <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.axis')}: {customerRecommendation.customerRecommendationItemLeft.axis}</span>}
                      {customerRecommendation.customerRecommendationItemLeft.add &&
                        <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.addfield')}: {customerRecommendation.customerRecommendationItemLeft.add}</span>}
                      {customerRecommendation.customerRecommendationItemLeft.color &&
                        <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.color')}: {customerRecommendation.customerRecommendationItemLeft.color}</span>}
                    </div>
                  </div>
                  <div className='row'>
                    <div className={leftArticleNumber === rightArticleNumber ? 'column small-6' : 'column small-3'}>
                      <select disabled className='my-recommendations__disabled-select' value={customerRecommendation.customerRecommendationItemLeft.packet}>
                        <option>{customerRecommendation.customerRecommendationItemLeft.packet} {translate('coptikk.price.unit')} {customerRecommendation.customerRecommendationItemLeft.price},-</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          {lastOrderDetails && index === lastOrderDetails.length - 1 ?
            <div className="my-recommendations__buy-button-wrapper">
              {getSubscriptionSelectionSection(index)}
              <span>
                <a className={`button buy-button product-detail__buy-button ${(anyProductNotBuyable || noOptionSelected) ? "  disabled" : ""}`}
                    onClick={() => addItemsToCart()}
                  >
                  {anyProductNotBuyable ? translate("coptikk.mypage.notbuyable") : translate("coptikk.product.buy")}
                </a>
              </span>
            </div> : <div className="my-recommendations__buy-button-wrapper"></div>}
        </div>
      })}
    </Fragment>
  );
};

export default MyPageRecommendationLastOrder;
